import { c as _c } from "react/compiler-runtime";
import { Pagination } from '../pagination/pagination.tsx';
import { Review } from '../review/review.tsx';
export type ReviewsListProps = {
  reviews?: object[];
  updatePage: (page: number, rating: number | undefined) => void;
  rating?: number;
};
export const ReviewsList: React.FC<ReviewsListProps> = t0 => {
  const $ = _c(15);
  const {
    reviews,
    updatePage,
    rating
  } = t0;
  let t1;
  if ($[0] !== rating || $[1] !== updatePage) {
    t1 = page => {
      updatePage(page, rating);
    };
    $[0] = rating;
    $[1] = updatePage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePageChange = t1;
  let t2;
  if ($[3] !== reviews) {
    t2 = reviews?.map(_temp);
    $[3] = reviews;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex flex-col gap-comfy-xl">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = reviews?.length || 0;
  let t5;
  if ($[7] !== handlePageChange) {
    t5 = page_0 => handlePageChange(page_0);
    $[7] = handlePageChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Pagination totalItems={t4} initialPage={0} itemsPerPage={10} onPageChange={t5} />;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(review, index) {
  return <Review name={(review as {
    firstname: string;
  }).firstname} sponsorDuration={(review as {
    Sponsor: string;
  }).Sponsor} location={(review as {
    location: string;
  }).location} reviewTitle={(review as {
    headline: string;
  }).headline} rating={Number((review as {
    overall: string;
  }).overall)} review={(review as {
    Comments: string;
  }).Comments} recommendsCompassion={(review as {
    recommend: string;
  }).recommend !== "0"} key={(review as {
    firstname: string;
  }).firstname + index} />;
}